'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';

const ConsentPropertiesReducer = (state = ImmutableMap(), action) => {
  switch (action.type) {
    case Actions.CONSENT_PROPERTIES_FETCH_SUCCEEDED:
      {
        if (!action.payload) {
          return state;
        }

        state = action.payload.results;
        return state;
      }

    default:
      {
        return state;
      }
  }
};

export default ConsentPropertiesReducer;